/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_AccessInputs */

const en_nav_section_access = /** @type {(inputs: Nav_Section_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access`)
};

/**
* | output |
* | --- |
* | "Access" |
*
* @param {Nav_Section_AccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_access = /** @type {((inputs?: Nav_Section_AccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_AccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_access(inputs)
});